export const BASE_URL="https://universevisuals.in/api"